// eslint-disable-next-line
import React from "react";
import "./aboutInfoContainer.css";

const AboutVissionAndMission = ({ title, textOne, textTwo, image, id }) => {
  return (
    <>
      <div className="about-info-container">
        <p className="title-text-about" id={id || ""}>
          {title}
        </p>
        <p className="description-text">{textOne}</p>
        <p className="description-text">{textTwo}</p>
      </div>
      {image ? image : null}
    </>
  );
};

export default AboutVissionAndMission;
